import { Circle2d } from '../circle2d';
import { Line2d } from '../Line2d';
import { LineSeg2d } from '../LineSeg2d';
import { ArcSeg2d } from '../arcSeg2d';
import { IShape2d } from '@/editor/types/shape';
import { thresholdValue } from '../const';
import { IPoint2d } from '../IPoint2d';
import { Point2dUtils } from '../Point2dUtils';
import { IVector2d } from '@/editor/types/math';

export function isCircleAngLineTangent(circle: Circle2d, line: Line2d): boolean {
  const distance = line.pointToLineDistance(circle.center);
  return Math.abs(distance - circle.radius) < thresholdValue;
}

// 判断两图元是否想切
export function isTangent(seg1: IShape2d, seg2: IShape2d): boolean {
  // 直线与直线是否平行
  if (seg1 instanceof Line2d && seg2 instanceof Line2d) {
    return seg1.isParallelTo(seg2);
  }
  if (seg1 instanceof LineSeg2d && seg2 instanceof LineSeg2d) {
    return seg1.isParallel(seg2);
  }

  // 圆与圆是否相切
  if (seg1 instanceof Circle2d && seg2 instanceof Circle2d) {
    return seg1.isTangentTo(seg2);
  }

  // 圆弧与圆弧是否相切
  if (seg1 instanceof ArcSeg2d && seg2 instanceof ArcSeg2d) {
    return seg1.isTangentTo(seg2);
  }

  // 圆与直线是否相切
  if (seg1 instanceof Circle2d && seg2 instanceof Line2d) {
    return isCircleAngLineTangent(seg1, seg2);
  }
  if (seg1 instanceof Line2d && seg2 instanceof Circle2d) {
    return isCircleAngLineTangent(seg2, seg1);
  }

  // 圆弧与直线是否相切
  // if (seg1 instanceof ArcSeg2d && seg2 instanceof Line2d) {
  //   return seg1.isTangentTo(seg2);
  // }
  // if (seg1 instanceof Line2d && seg2 instanceof ArcSeg2d) {
  //   return seg2.isTangentTo(seg1);
  // }

  return false;
}

// 获取图元的切线方向
export function getTangentDirection(seg: IShape2d, point: IPoint2d): IVector2d {
  if (seg instanceof LineSeg2d) {
    return seg.getDirectionVector();
  }
  if (seg instanceof ArcSeg2d) {
    const pointDirection = Point2dUtils.getDirection(seg.center, point);
    return Point2dUtils.rotateDirection(pointDirection, (Math.PI / 2) * (seg.clockwise ? -1 : 1));
  }

  return { x: 0, y: 0 };
}
